export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/file-audio-11a97f8f342e3469332b708bb2359f25.svg";